import Header from "../../component/header/header";
import "./Subject.style.scss";
import { FiBook } from "react-icons/fi";
import { listSubject, deleteSubjectData } from "../../api/subject";
import { useEffect, useState, useCallback } from "react";
import { SubjectProps } from "./SubjectInterface";
import {
  limitPagination,
  LoaderComponent,
  successMessage,
} from "../../utils/Helper";
import { useNavigate } from "react-router-dom";
import { errorMessageShow } from "../../utils/Helper";
import { SubjectCard } from "./SubjectCard";
import Pagination from "../../component/pagination/pagination";

const Subjects: React.FC = () => {
  const [subjectData, setSubjectData] = useState<SubjectProps[]>([]);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState<number>(1);
  const [searchKey, setSearchKey] = useState<string>("");
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);
  const navigate = useNavigate();
  const [seachBtnClick, setSearchBtnClick] = useState<number>(0);

  const fetchSubjectData = useCallback(
    async (searchKey: string) => {
      try {
        setLoading(true);
        const response = await listSubject(searchKey ? 1 : page, searchKey);
        console.log(response, "response data");
        const subjects = response?.data?.data?.subjects || [];
        const total = response?.data?.data?.total || 1;
        if (searchKey) {
          setPage(1);
        }
        setSubjectData(subjects);
        setTotalPage(total);
        setError(null);
      } catch (error) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    },
    [page]
  );

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        fetchSubjectData(searchKey);
      },
      seachBtnClick === 0 ? 500 : 0
    );
    return () => clearTimeout(delayDebounceFn);
  }, [searchKey, page, seachBtnClick]);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKey(e.target.value);
  };

  const deleteSubject = async (subjectId: string | number) => {
    try {
      const delSubject = await deleteSubjectData(subjectId);
      if (delSubject) {
        setSubjectData((prevSubject) =>
          prevSubject.filter((subject) => subject.id !== subjectId)
        );
        successMessage("Subject deleted successfully!");
      }
    } catch (error) {}
  };

  const handleSubjectUpdate = (updatedSubject: SubjectProps) => {
    const subjectId = updatedSubject?.data?.id;
    if (subjectId) {
      const updateData = updatedSubject?.data;
      setSubjectData((prevData) => {
        return prevData.map((subject) => {
          if (subject.id === subjectId) {
            return { ...subject, ...updateData };
          }
          return subject;
        });
      });
    }
  };

  const onSearchButtonClick = () => {
    if (searchKey) {
      setSearchBtnClick((prev) => prev + 1);
      setPage(1);
    }
  };

  return (
    <div className="content subject_page">
      <Header
        pageTitle={`Subjects`}
        // pageTitle={`Subjects ${totalPage > 0 ? `(${totalPage}/ ${subjectData.length})` : ""}`}
        buttonText="Add Subjects"
        buttonIcon={<FiBook fontSize={20} />}
        isHeader
        onSearchChange={onSearchChange}
        search={searchKey}
        onClick={() => navigate("/subjects/create")}
        onSearchClick={onSearchButtonClick}
      />

      {loading ? (
        <LoaderComponent fillPage label="Loading subjects…" />
      ) : (
        <div className="subject_page_container">
          {subjectData.length > 0 ? (
            subjectData.map((subject, index) => {
              return (
                <SubjectCard
                  key={subject.id}
                  data={subject}
                  index={index}
                  openMenuIndex={openMenuIndex}
                  setOpenMenuIndex={setOpenMenuIndex}
                  deleteSubject={deleteSubject}
                  onSubjectUpdate={handleSubjectUpdate}
                />
              );
            })
          ) : error ? (
            <div>{error}</div>
          ) : (
            <div>No data found</div>
          )}
        </div>
      )}
      {!loading || subjectData.length > 0 ? (
        <Pagination
          postsPerPage={limitPagination}
          length={totalPage}
          currentPage={page}
          handlePagination={(newPage: number) => setPage(newPage)}
        />
      ) : null}
    </div>
  );
};

export default Subjects;
